var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.90625C10.3128 1.90883 8.21584 2.77885 6.66923 4.32547C5.12261 5.87209 4.25259 7.96901 4.25001 10.1562C4.24739 11.9437 4.83124 13.6826 5.91201 15.1063C5.91201 15.1063 6.13701 15.4025 6.17376 15.4452L12.5 22.9062L18.8293 15.4415C18.8623 15.4018 19.088 15.1063 19.088 15.1063L19.0888 15.104C20.169 13.681 20.7526 11.9428 20.75 10.1562C20.7474 7.96901 19.8774 5.87209 18.3308 4.32547C16.7842 2.77885 14.6873 1.90883 12.5 1.90625ZM12.5 13.1562C11.9067 13.1562 11.3266 12.9803 10.8333 12.6507C10.34 12.321 9.95543 11.8525 9.72837 11.3043C9.50131 10.7561 9.4419 10.1529 9.55765 9.57098C9.67341 8.98904 9.95913 8.45449 10.3787 8.03493C10.7982 7.61537 11.3328 7.32965 11.9147 7.21389C12.4967 7.09814 13.0999 7.15755 13.6481 7.38461C14.1962 7.61167 14.6648 7.99619 14.9944 8.48954C15.3241 8.98289 15.5 9.56291 15.5 10.1562C15.499 10.9516 15.1826 11.7141 14.6202 12.2765C14.0578 12.8389 13.2954 13.1553 12.5 13.1562Z",
    fill: "#212529"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.d5aaa66564cb39dc4e81b1b32aecada3.svg";
export { ForwardRef as ReactComponent };